// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  display: block;
}

`, "",{"version":3,"sources":["webpack://./src/components/TitleBar/titleBar.scss","webpack://./src/components/TitleBar/titleBar.css"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iDAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sEAAA;EACA,qBAAA;EACA,uCAAA;EACA,sBAAA;EACA,cAAA;ACCF","sourcesContent":[".page-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  display: block; \n}\n",".page-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  display: block;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
